export default "__VITE_ASSET__DlQAdaRy__"